import { memo } from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';

import { InputText } from '../input-text/index';
import type { TextFieldProps } from '@mui/material';

type AutocompleteProps = {
  inputProps: TextFieldProps;
} & any;

export const AutoComplete = memo<AutocompleteProps>(function Autocomplete({
  inputProps,
  ...props
}: AutocompleteProps) {
  return (
    <MuiAutocomplete
      multiple
      freeSolo
      renderTags={(value: readonly string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Chip
            key={index}
            label={option}
            {...(getTagProps({ index }) as any)}
          />
        ))
      }
      options={[]}
      renderInput={(params) => <InputText {...params} {...inputProps} />}
      {...props}
    />
  );
});
